import { isString } from 'lodash';

import type { IMediaManagement } from '@/services/mediaManagement/interface';
import { post, read, update } from '@/utils/request';
import { mediaStore } from '@/utils/common/newMedia';

// 媒体列表
const getMediaManagementList = (
  params?: IMediaManagement.Request.GetMediaManagementList,
  signal?: AbortController['signal'],
) => {
  return post<IMediaManagement.Response.GetMediaManagementList>(
    'media_management/list',
    {
      ...params,
      media_key_array: isString(params?.media_key_array)
        ? [params?.media_key_array]
        : params?.media_key_array,
      order_by_field: params?.sort_by,
      order_by_type: params?.order,
    },
    undefined,
    undefined,
    {
      isCamel: false,
      isLower: false,
      signal,
    },
  );
};

// 新兴媒体开户媒体列表
const getSmallMediaList = async () => {
  const [mediaList] = await getMediaManagementList({ page_size: 9999 });
  if (mediaList) {
    return mediaList?.list?.map((item) => ({
      ...item,
      value: item?.media_key,
      title: item?.media_name,
    }));
  }
  return [];
};

// 新兴媒体开户媒体列表 去除 bing & snapchat
const getSmallMediaListWithoutBingSnapchat = async () => {
  const list = await getSmallMediaList();
  return (
    list?.filter(
      (item) =>
        ![mediaStore.allMediaStringMap.Bing, mediaStore.allMediaStringMap.Snapchat].includes(
          item?.media_key_value,
        ),
    ) ?? []
  );
};

// 媒体详情
const getMediaManagementDetail = (id: IMediaManagement.Common.MediaMetaInfo['id']) => {
  return read<IMediaManagement.Response.MediaManagementDetail>(
    'media_management',
    undefined,
    '获取媒体详情失败',
    id,
    {
      isCamel: false,
      isLower: false,
    },
  );
};

// 新建媒体
const addMediaManagement = (params: IMediaManagement.Request.AddMediaManagement) => {
  return post('media_management', params, undefined, undefined, {
    isCamel: false,
    isLower: false,
  });
};

// 编辑媒体
const editMediaManagement = (
  params: IMediaManagement.Request.AddMediaManagement,
  id?: IMediaManagement.Common.MediaMetaInfo['id'],
) => {
  return update('media_management', params, undefined, id, {
    isCamel: false,
    isLower: false,
  });
};

// 检查媒体是否已存在
const checkMediaManagement = (media_name: string) => {
  return post<IMediaManagement.Response.CheckMediaManagement>(
    'media_management/check',
    { media_name },
    undefined,
    undefined,
    {
      isCamel: false,
      isLower: false,
    },
  );
};

// 媒体下拉列表
const getMediaLists = (params?: IMediaManagement.Request.GetMediaLists) => {
  return read<IMediaManagement.Response.GetMediaLists>(
    'media_management/select',
    params,
    undefined,
    undefined,
    {
      isCamel: false,
      isLower: false,
    },
  );
};

export {
  getMediaManagementList,
  getMediaManagementDetail,
  addMediaManagement,
  editMediaManagement,
  checkMediaManagement,
  getMediaLists,
  getSmallMediaList,
  getSmallMediaListWithoutBingSnapchat,
};
